// Module
var code = "<p class=\"ib-flights-message__item-text--small ib-text ib-text--color-light\">{{'POP_OVER_ACCESSIBILITY_INFO'|translate}}<b>{{'POP_OVER_ACCESSIBILITY_INFO_BOLD'|translate}}</b></p>\n";
// Exports
module.exports = code;